export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}
export function formatNumberValue(value, maximumDecimals, minimumDigits) {
    const formatter = new Intl.NumberFormat(undefined, {
        maximumFractionDigits: maximumDecimals ?? 0,
        minimumIntegerDigits: minimumDigits ?? 1,
    });
    return formatter.format(value);
}
/**
 * Rule structure for react-hook-form
 */
export const EMAIL_RULE = {
    message: `Please enter a valid email address`,
    value: /^[\w\-.\d*]+@[\w\-\d.]+(\.\w*)$/,
};
export function generateAuthorsString(names) {
    const string = names.length > 1
        ? `${names.slice(0, -1).join(', ')} and ${names.slice(-1)}`
        : { 0: '', 1: names[0] }[names.length];
    return `Article by: ${string}`;
}
export const highlightTitleWords = (title) => title.replaceAll(/\*([\w\W]+)\*/g, '<span>$1</span>');
